//src/app/core/services/order.service.ts
import {
    HttpClient,
    HttpErrorResponse,
    HttpParams,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root",
})
export class OrderService {
    constructor(private http: HttpClient) { }

    private orderService = environment.orderService + "/v1";

    updateOrder(payload: any): Observable<any> {
        return this.http
            .put<any>(this.orderService + `/order/${payload._id}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    createOrder(payload: any): Observable<any> {
        return this.http
            .post<any>(
                this.orderService + `/order/admin-PP6apqnjXJGDtwA-order`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getOrderList(
        payload: any,
        page: any = 1,
        pageSize: any = 10
    ): Observable<any> {
        return this.http
            .post<any>(
                this.orderService +
                `/order/all?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getOrderById(id: any): Observable<any> {
        return this.http
            .get<any>(this.orderService + `/order/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    getOrderIdByOrderNumber(orderNumber: any): Observable<any> {
        return this.http
            .get<any>(this.orderService + `/order/order-number/${orderNumber}`)
            .pipe(catchError((err) => throwError(err)));
    }

    getOrderActivityLog(id: any): Observable<any> {
        return this.http
            .get<any>(this.orderService + `/order-activity/order/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    updateBulkOrderStatus(payload: any): Observable<any> {
        return this.http
            .put<any>(this.orderService + "/order/bulk-status-update", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    //****** Archive Order *******//

    createArchiveOrder(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + `/archive-order`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getAllArchiveOrder(payload: any): Observable<any> {
        return this.http
            .post<any>(
                this.orderService +
                `/archive-order/get-all?page=${payload.page}&pageSize=${payload.pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getArchiveOrderById(id: any): Observable<any> {
        return this.http
            .get<any>(this.orderService + `/archive-order/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    getArchiveOrderReport(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + `/archive-order/get-report`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    //****** Invoice ******//

    createInvoice(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + `/invoice`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    updateInvoice(payload: any): Observable<any> {
        return this.http
            .put<any>(this.orderService + `/invoice/${payload._id}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    deleteInvoice(id: any): Observable<any> {
        return this.http
            .delete<any>(this.orderService + `/invoice/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }
    getInvoiceById(id: any): Observable<any> {
        return this.http
            .get<any>(this.orderService + `/invoice/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    getInvoiceIdByInvoiceNumber(invoiceNumber: any): Observable<any> {
        return this.http
            .get<any>(
                this.orderService + `/invoice/invoice-number/${invoiceNumber}`
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getInvoice(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http
            .post<any>(
                this.orderService +
                `/invoice/all?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }
    getSimpleInvoice(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http
            .post<any>(
                this.orderService +
                `/invoice/simple-all?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getDeliveryPartner(payload: any): Observable<any> {
        return this.http
            .post<any>(
                this.orderService + `/shipping/checkServicability`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    viewPdf(url: string): Observable<Blob> {
        const options = { responseType: "blob" as "json" };
        return this.http
            .get<Blob>(url, options)
            .pipe(map((res) => new Blob([res], { type: "application/pdf" })));
    }

    generateInvoice(id: any): Observable<any> {
        return this.http
            .get(this.orderService + `/invoice/invoice-pdf/${id}?type=BUFFER`, {
                observe: "response",
                responseType: "blob",
            })
            .pipe(catchError((err) => throwError(err)));
    }

    //****** Estimate ******//

    createEstimate(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/estimate", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getEstimatesByCriteria(
        payload: any,
        page: any,
        pageSize: any
    ): Observable<any> {
        return this.http
            .post<any>(
                this.orderService +
                `/estimate/all?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getEstimateById(editId: any): Observable<any> {
        return this.http
            .get<any>(this.orderService + "/estimate/" + editId)
            .pipe(catchError((err) => throwError(err)));
    }

    updateEstimate(payload: any, editId: any): Observable<any> {
        return this.http
            .put<any>(this.orderService + "/estimate/" + editId, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    deleteEstimate(deleteId: any): Observable<any> {
        return this.http
            .delete<any>(this.orderService + "/estimate/" + deleteId)
            .pipe(catchError((err) => throwError(err)));
    }

    //****** Order Export ******//

    orderExport(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/order/export", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    //****** Bills API ******//

    createBill(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/bill", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getAllBill(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/bill/all", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getBillById(editId: any): Observable<any> {
        return this.http
            .get<any>(this.orderService + "/bill/" + editId)
            .pipe(catchError((err) => throwError(err)));
    }

    updateBill(payload: any, editId: any): Observable<any> {
        return this.http
            .put<any>(this.orderService + "/bill/" + editId, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    deleteBill(deleteId: any): Observable<any> {
        return this.http
            .delete<any>(this.orderService + "/bill/" + deleteId)
            .pipe(catchError((err) => throwError(err)));
    }

    //****** Payment API ******//

    createPayment(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/payment", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getPaymentByCriteria(
        payload: any,
        page: any,
        pageSize: any
    ): Observable<any> {
        return this.http
            .post<any>(
                this.orderService +
                `/payment/all?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    deletePayment(deleteId: any): Observable<any> {
        return this.http
            .delete<any>(this.orderService + "/payment/" + deleteId)
            .pipe(catchError((err) => throwError(err)));
    }

    //****** Transaction API ******//

    createTransaction(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/transactionLogs", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    createTransactionBulk(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/transactionLogs", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    updateTransaction(payload: any): Observable<any> {
        return this.http
            .put<any>(
                this.orderService + "/transactionLogs/" + payload._id,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getTransactionLogByCriteria(
        payload: any,
        page: any,
        pageSize: any
    ): Observable<any> {
        return this.http
            .post<any>(
                this.orderService +
                `/transactionLogs/all?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getTransactionLogDaily(
        payload: any,
        page: any,
        pageSize: any
    ): Observable<any> {
        return this.http
            .post<any>(
                this.orderService +
                `/transactionLogs/daily?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    /**
     * Calls the backend API to generate a PayU Payment Link for a given order.
     * @param orderId The internal MongoDB ObjectId of the order.
     * @returns An Observable containing the API response, including the paymentLink URL.
     */
    generatePayuPaymentLink(orderId: string, amount: number): Observable<any> {
        const payload = { orderId: orderId, amount: amount }
        return this.http
            .post<any>(
                this.orderService + "/transaction/create-payu-payment-link",
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getVendorTransactionLogDaily(
        payload: any,
        page: any,
        pageSize: any
    ): Observable<any> {
        return this.http
            .post<any>(
                this.orderService +
                `/transactionLogs/vendor-daily?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getDTDCPending(reconStatus: string = ""): Observable<any> {
        let params = new HttpParams();
        if (reconStatus) {
            params = params.set("reconStatus", reconStatus);
        }

        return this.http
            .get<any>(`${this.orderService}/transactionLogs/dtdc/pending`, {
                params,
            })
            .pipe(catchError((err) => throwError(err)));
    }

    //****** RFQ API ******//

    getAllRfq(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http
            .post<any>(
                this.orderService +
                `/rfq/all?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }
    getRfqById(id: any): Observable<any> {
        return this.http
            .get<any>(this.orderService + "/rfq/" + id)
            .pipe(catchError((err) => throwError(err)));
    }

    getSellerQuotationByCriteria(
        payload: any,
        page: any,
        pageSize: any
    ): Observable<any> {
        return this.http
            .post<any>(
                this.orderService +
                `/sellerQuotation/all?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    updateSellerQuotation(payload: any, id: any): Observable<any> {
        return this.http
            .put<any>(this.orderService + "/sellerQuotation/" + id, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    updateRfq(payload: any, id: any): Observable<any> {
        return this.http
            .put<any>(this.orderService + "/rfq/" + id, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    //****** Sales Dashboard API ******//

    getSalesDashboard(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/order/salesDashboard", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getTotalPurchaseCount(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/purchase/total", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getTotalDebitCount(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/debit/total", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getTotalCreditCount(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/credit/total", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getTopCollection(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/order/topCollection", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getTopProducts(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/order/topProducts", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    createPurchase(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + `/purchase`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    updatePurchase(payload: any): Observable<any> {
        return this.http
            .put<any>(this.orderService + `/purchase/${payload._id}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getPurchaseList(
        payload: any,
        page: any = 1,
        pageSize: any = 10
    ): Observable<any> {
        return this.http
            .post<any>(
                this.orderService +
                `/purchase/all?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getPurchaseById(id: any): Observable<any> {
        return this.http
            .get<any>(this.orderService + `/purchase/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    deletePurchase(id: any): Observable<any> {
        return this.http
            .delete<any>(this.orderService + `/purchase/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    downloadPurchase(id: any): Observable<any> {
        return this.http
            .get(
                this.orderService + `/purchase/invoice-pdf/${id}?type=BUFFER`,
                {
                    observe: "response",
                    responseType: "blob",
                }
            )
            .pipe(catchError((err) => throwError(err)));
    }

    createDebit(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + `/debit`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    updateDebit(payload: any): Observable<any> {
        return this.http
            .put<any>(this.orderService + `/debit/${payload._id}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getDebitList(
        payload: any,
        page: any = 1,
        pageSize: any = 10
    ): Observable<any> {
        return this.http
            .post<any>(
                this.orderService +
                `/debit/all?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getDebitById(id: any): Observable<any> {
        return this.http
            .get<any>(this.orderService + `/debit/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    getDebitPdfById(id: any): Observable<any> {
        return this.http
            .get(this.orderService + `/debit/invoice-pdf/${id}?type=BUFFER`, {
                observe: "response",
                responseType: "blob",
            })
            .pipe(catchError((err) => throwError(err)));
    }

    deleteDebit(id: any): Observable<any> {
        return this.http
            .delete<any>(this.orderService + `/debit/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }
    createCredit(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + `/credit`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    updateCredit(payload: any): Observable<any> {
        return this.http
            .put<any>(this.orderService + `/credit/${payload._id}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    generateCredit(id: any): Observable<any> {
        return this.http
            .get(this.orderService + `/credit/invoice-pdf/${id}?type=BUFFER`, {
                observe: "response",
                responseType: "blob",
            })
            .pipe(catchError((err) => throwError(err)));
    }

    getCreditIdByCreditNumber(creditNumber: any): Observable<any> {
        return this.http
            .get<any>(
                this.orderService + `/credit/credit-number/${creditNumber}`
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getCreditList(
        payload: any,
        page: any = 1,
        pageSize: any = 10
    ): Observable<any> {
        return this.http
            .post<any>(
                this.orderService +
                `/credit/all?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getCreditById(id: any): Observable<any> {
        return this.http
            .get<any>(this.orderService + `/credit/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    deleteCredit(id: any): Observable<any> {
        return this.http
            .delete<any>(this.orderService + `/credit/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    getTotalTransactionByPaymentMode(payload: any): Observable<any> {
        return this.http
            .post<any>(
                this.orderService + `/transactionLogs/total-by-paymode`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    //----- reports

    getCustomSalesReport(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/sales-report/custom", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getCustomSalesReportWidgets(payload: any): Observable<any> {
        return this.http
            .post<any>(
                this.orderService + "/sales-report/custom-widgets",
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }
    getSalonReports(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + `/analytics/salon-list`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getPurchaseReports(payload: any): Observable<any> {
        return this.http
            .post<any>(
                this.orderService + `/analytics/product-purchases`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getSalonsNotPurchasing(payload: any): Observable<any> {
        return this.http
            .post<any>(
                this.orderService + `/analytics/salon-not-purchasing`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getDormatSalons(): Observable<any> {
        return this.http
            .post<any>(this.orderService + `/analytics/dormat-salon`, {})
            .pipe(catchError((err) => throwError(err)));
    }

    getInventoryDurationReports(payload: any): Observable<any> {
        return this.http
            .post<any>(
                this.orderService + `/analytics/inventory-duration`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getBrandsReport(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/analytics/brand-wise", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getOrderProcessingReport(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/analytics/order-tat", payload)
            .pipe(catchError((err) => throwError(err)));
    }
    getDueOrderReport(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/analytics/due-invoices", payload)
            .pipe(catchError((err) => throwError(err)));
    }
    getSalesAgentsReport(payload: any): Observable<any> {
        return this.http
            .post<any>(
                this.orderService + "/analytics/agent-wise-sales",
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }
    generateSalesAgentsReport(payload: any): Observable<any> {
        return this.http
            .post<any>(
                this.orderService + "/analytics/sales-agent-report",
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    exportFinancePurchase(payload: any): Observable<any> {
        return this.http
            .post<any>(
                this.orderService + "/analytics/finance-purchase",
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    exportFinanceSale(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/analytics/finance-sale", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    exportInvoice(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/analytics/export-invoice", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    exportFinanceCredit(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/analytics/finance-credit", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    exportFinanceHsn(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/analytics/finance-hsn", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    exportSaleR1(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/analytics/sales-r1", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    exportCreditR1(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/analytics/credits-r1", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    exportHsnSaleR1(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/analytics/sales-r1-hsn", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    exportHsnCreditR1(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/analytics/credits-r1-hsn", payload)
            .pipe(catchError((err) => throwError(err)));
    }
    getShopLedger(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + "/analytics/shop-ledger", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    //Performa Invoice
    getPerformaInvoice(
        payload: any,
        page: any,
        pageSize: any
    ): Observable<any> {
        return this.http
            .post<any>(
                this.orderService +
                `/performa-invoice/get?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }
    createPerformaInvoice(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + `/performa-invoice/`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getPerformaInvoiceById(id: any): Observable<any> {
        return this.http
            .get<any>(this.orderService + `/performa-invoice/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    getTransactionLogs(payload: any): Observable<any> {
        return this.http
            .post<any>(
                this.orderService + `/transactionLogs/pdf?type=BUFFER`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    genereateTransactionLogs(payload: any): Observable<any> {
        return this.http
            .post(
                this.orderService + `/transactionLogs/pdf?type=BUFFER`,
                payload,
                {
                    observe: "response",
                    responseType: "blob",
                }
            )
            .pipe(catchError((err) => throwError(err)));
    }

    updatePerformaInvoice(payload: any): Observable<any> {
        return this.http
            .put<any>(this.orderService + `/performa-invoice`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    generatePerformaInvoice(id: any): Observable<any> {
        return this.http
            .get(
                this.orderService + `/performa-invoice/pdf/${id}?type=BUFFER`,
                {
                    observe: "response",
                    responseType: "blob",
                }
            )
            .pipe(catchError((err) => throwError(err)));
    }

    createRFQ(payload: any): Observable<any> {
        return this.http
            .post(this.orderService + `/rfq`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    updateRFQ(payload: any): Observable<any> {
        return this.http
            .put(this.orderService + `/rfq/${payload._id}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getRFQ(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http
            .post(
                this.orderService +
                `/rfq/all?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getRFQById(id: any): Observable<any> {
        return this.http
            .get(this.orderService + `/rfq/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    createRFQTimeline(payload: any): Observable<any> {
        return this.http
            .post(this.orderService + `/rfq-timeline`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getRFQTimeLine(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http
            .post(
                this.orderService +
                `/rfq-timeline/all?page=${page}&pageSize=${pageSize}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    //****** Tracking ******//

    getTrackingDetailsByShipmentId(payload: any): Observable<any> {
        return this.http
            .post<any>(
                this.orderService + `/shipping/trackingDetailsByShipmentId`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    getSalesAgents(): Observable<any> {
        return this.http
            .get<any>(this.orderService + `/target/sales-agents`)
            .pipe(catchError((err) => throwError(err)));
    }

    createTarget(targetData: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + `/target/agent-targets`, targetData)
            .pipe(catchError((err) => throwError(err)));
    }

    getAllTargets(): Observable<any> {
        return this.http
            .get<any>(this.orderService + `/target/agent-targets`)
            .pipe(catchError((err) => throwError(err)));
    }

    getTarget(id: string): Observable<any> {
        return this.http
            .get<any>(this.orderService + `/target/agent-targets/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    updateTarget(id: string, updatedTarget: any): Observable<any> {
        return this.http
            .put<any>(
                this.orderService + `/target/agent-targets/${id}`,
                updatedTarget
            )
            .pipe(catchError((err) => throwError(err)));
    }

    deleteTarget(id: string): Observable<any> {
        return this.http
            .delete<any>(this.orderService + `/target/agent-targets/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    //* Extra Expenses *//
    getAllShippingPartners(): Observable<any> {
        return this.http
            .get<any>(this.orderService + `/shipping-partners/`)
            .pipe(catchError((err) => throwError(err)));
    }

    getShippingPartnerByOrderId(orderId: string): Observable<any> {
        return this.http
            .get<any>(this.orderService + `/shipping-partners/${orderId}`)
            .pipe(catchError((err) => throwError(err)));
    }

    createShippingPartner(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + `/shipping-partners`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    updateShippingPartner(orderId: string, payload: any): Observable<any> {
        return this.http
            .put<any>(
                this.orderService + `/shipping-partners/${orderId}`,
                payload
            )
            .pipe(catchError((err) => throwError(err)));
    }

    deleteShippingPartner(orderId: string): Observable<any> {
        return this.http
            .delete<any>(this.orderService + `/shipping-partners/${orderId}`)
            .pipe(catchError((err) => throwError(err)));
    }
    getInventoryDiscrepancies(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + `/analytics/inventory-cron`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    /**
     * Check inventory shortage for orders
     * @param payload - { orderId?: string } - Optional specific order ID, or checks all pending orders
     * @returns Observable with inventory shortage data
     */
    checkInventoryShortage(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + `/order/check-inventory-shortage`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    /**
     * Get dashboard widget statistics
     * @param payload - Filter criteria (same as getOrderList)
     * @returns Observable with widget stats: totalOrders, newOrders, pendingOrders, criticalDelays, inventoryShortage, customerReachout
     */
    getWidgetsStats(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + `/order/widgets-stats`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    // In order.service.ts
    createSignOff(payload: any): Observable<any> {
        return this.http
            .post<any>(`${this.orderService}/sign-off/`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getSignOffStatus(warehouseId: string): Observable<any> {
        return this.http
            .get<any>(`${this.orderService}/sign-off/${warehouseId}`)
            .pipe(catchError((err) => throwError(err)));
    }
    //Shiprocket Routes
    // Method to create Shiprocket order
    createShiprocketOrder(payload: any): Observable<any> {
        return this.http
            .post<any>(this.orderService + `/shiprocket/orders/create`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    // =================================================================
    // START: NEW SHIPROCKET API METHODS
    // =================================================================

    /**
     * @description Gets specific order details from Shiprocket using its unique order ID.
     * @param orderId The Shiprocket order ID (e.g., 890618843).
     * @returns An Observable with the detailed order data.
     */
    getShiprocketOrderDetails(orderId: string | number): Observable<any> {
        // This uses a GET request as defined in the backend router.
        return this.http
            .get<any>(
                `${this.orderService}/shiprocket/orders/orders/${orderId}`
            )
            .pipe(catchError((err) => throwError(err)));
    }

    /**
     * @description Gets specific shipment details from Shiprocket using its unique shipment ID.
     * @param shipmentId The Shiprocket shipment ID (e.g., 886941750).
     * @returns An Observable with the detailed shipment data.
     */
    getShiprocketShipmentDetails(shipmentId: string | number): Observable<any> {
        // This uses a GET request as defined in the backend router.
        return this.http
            .get<any>(
                `${this.orderService}/shiprocket/orders/shipments/${shipmentId}`
            )
            .pipe(catchError((err) => throwError(err)));
    }

    /**
     * @description Syncs Shiprocket order data with local order - fetches latest status updates, expenses, and transactions.
     * @param orderId The local order ID (e.g., "SO/25-26/0006577").
     * @returns An Observable with sync summary including shipments processed, status updates, expenses added, and transactions created.
     */
    syncShiprocketOrder(orderId: string): Observable<any> {
        return this.http
            .post<any>(
                `${this.orderService}/shiprocket/orders/sync-order`,
                { orderId }
            )
            .pipe(catchError((err) => throwError(err)));
    }

    // =================================================================
    // END: NEW SHIPROCKET API METHODS
    // =================================================================

    // Method to get tracking details by shipment ID
    getShipRocketTrackingDetailsByShipmentId(shipmentId: any): Observable<any> {
        return this.http
            .post<any>(
                this.orderService +
                `/shiprocket/orders/trackingDetailsByShipmentId`,
                { shipmentId }
            )
            .pipe(catchError((err) => throwError(err)));
    }
}
